import { render, staticRenderFns } from "./ContributionHistory.vue?vue&type=template&id=ded3bdde&"
import script from "./ContributionHistory.vue?vue&type=script&lang=js&"
export * from "./ContributionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports